import * as _moment from 'moment';
const moment = _moment;

export class DateFormatter {
    date: Date;

    constructor(date: string | Date | number) {
        this.date = new Date(date);
    }

    formatFullYear() {
        return moment(this.date).format('DD/MM/YYYY, H:mm');
    }

    formatYear() {
        return moment(this.date).format('DD/MM/YYYY');
    }

    formatMonth() {
        return moment(this.date).format('DD/MM, H:mm');
    }

    formatDate() {
        return moment(this.date).format('DD/MM, H:mm');
    }

    formatTime() {
        return moment(this.date).format('H:mm');
    }

    format() {
        if (!this.date.getTime()) {
            return '';
        }
        const now = new Date();
        const conditions = {
            onYear: now.getFullYear() === this.date.getFullYear(),
            onMonth: now.getMonth() === this.date.getMonth(),
            onDate: now.getDate() === this.date.getDate(),
        };
        if (conditions.onYear && conditions.onMonth && conditions.onDate) {
            return this.formatTime();
        }
        if (conditions.onYear && conditions.onMonth) {
            return this.formatDate();
        }
        if (conditions.onYear) {
            return this.formatMonth();
        }
        return this.formatYear();
    }
}